import { Accordion, AccordionDetail, AccordionHeader, AccordionItem, AccordionTitle } from "@vds/accordions";
import { Icon } from "@vds/icons";
import Vector from "../../../../assets/Vector.png";
import Checkmark from "../../../../assets/checkmark.png";
import { colorMapping } from "../../../../global/utility/Utils";
import { useStatisticContext } from "../../contexts/StatisticContext";
import { STATISTICS_TEST_IDS } from "../../statisticsConstants";

const AppearanceSelection = () => {
  const {
    activeAppearanceAccordion,
    setActiveAppearanceAccordion,
    eventAppColorsClassList,
    selectLowerClothingColors,
    setSelectLowerClothingColors,
    selectUpperClothingColors,
    setSelectUpperClothingColors
  } = useStatisticContext();

  const toggleAppearanceAccordion = (index) => {
    setActiveAppearanceAccordion(activeAppearanceAccordion === index ? null : index);
  };

  const showColorAppearanceDetails = window.REACT_APP_STATS_COLOR_APPEARANCE;

  // Internal color handling functions (moved from parent component)
  const handleUpperColorToggle = (color) => {
    setSelectUpperClothingColors((prev) => {
      const currentColors = Array.isArray(prev) ? prev : Object.values(prev || {});
      const newSelectedColors = currentColors?.includes(color)
        ? currentColors?.filter((c) => c !== color) // Remove
        : [...currentColors, color]; // Add color
      return newSelectedColors;
    });
  };

  const renderUpperClothingColorBlocks = (colors) => {
    return (
      colors &&
      colors?.map((color, index) => {
        const isSelected = Array.isArray(selectUpperClothingColors) && selectUpperClothingColors?.includes(color);

        return (
          <div
            key={index}
            data-testid={STATISTICS_TEST_IDS.UPPER_CLOTHING_COLOR_BLOCK}
            onClick={() => handleUpperColorToggle(color)}
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50px",
              backgroundColor: colorMapping(color),
              display: "inline-block",
              marginRight: "10px",
              cursor: "pointer",
              position: "relative",
              border: color === "White" ? "1px solid #D8DADA" : "none",
              marginTop: "10px"
            }}
          >
            {isSelected && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: color === "White" ? "13px" : "10.89px",
                  height: color === "White" ? "11px" : "8.5px",
                  backgroundImage: `url(${color === "White" ? Checkmark : Vector})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat"
                }}
              />
            )}
          </div>
        );
      })
    );
  };

  const handleLowerColorToggle = (color) => {
    setSelectLowerClothingColors((prev) => {
      const currentColors = Array.isArray(prev) ? prev : Object.values(prev || {});
      const newSelectedColors = currentColors?.includes(color)
        ? currentColors?.filter((c) => c !== color) // Remove
        : [...currentColors, color]; // Add color
      return newSelectedColors;
    });
  };

  const renderLowerClothingColorBlocks = (colors) => {
    return (
      colors &&
      colors?.map((color, index) => {
        const isSelected = Array.isArray(selectLowerClothingColors) && selectLowerClothingColors?.includes(color);

        return (
          <div
            key={index}
            data-testid={STATISTICS_TEST_IDS.LOWER_CLOTHING_COLOR_BLOCK}
            onClick={() => handleLowerColorToggle(color)}
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50px",
              backgroundColor: colorMapping(color),
              display: "inline-block",
              marginRight: "10px",
              cursor: "pointer",
              position: "relative",
              border: color === "White" ? "1px solid #D8DADA" : "none",
              marginTop: "10px"
            }}
          >
            {isSelected && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: color === "White" ? "13px" : "10.89px",
                  height: color === "White" ? "11px" : "8.5px",
                  backgroundImage: `url(${color === "White" ? Checkmark : Vector})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat"
                }}
              />
            )}
          </div>
        );
      })
    );
  };

  const clearUpperClothingSelection = () => {
    setSelectUpperClothingColors([]);
  };

  const clearLowerClothingSelection = () => {
    setSelectLowerClothingColors([]);
  };

  const selectAllUpperClothingSelection = () => {
    setSelectUpperClothingColors(eventAppColorsClassList);
  };

  const selectAllLowerClothingSelection = () => {
    setSelectLowerClothingColors(eventAppColorsClassList);
  };

  if (!(showColorAppearanceDetails && eventAppColorsClassList.length > 0)) {
    return <></>;
  }

  return (
    <div className="filterTowerItems">
      <div className="filterTowerItemSeparator"></div>
      <div className="statisticsAccordion">
        <Accordion>
          <AccordionItem opened={activeAppearanceAccordion === 3} style={{ fontSize: "16px", width: "90%" }}>
            <AccordionHeader
              triggerType="icon"
              style={{ top: "8px" }}
              data-testid={STATISTICS_TEST_IDS.ACCORDION_HEADER_APPEARANCE}
              onClick={() => toggleAppearanceAccordion(3)}
            >
              <AccordionTitle>
                <div className="flexColumn">
                  <div className="flexRow">
                    <span style={{ paddingRight: "10px" }}>
                      <Icon name="clock" />
                    </span>
                    <p
                      style={{
                        fontWeight: "100",
                        margin: "0",
                        lineHeight: "27px"
                      }}
                      size="small"
                    >
                      Appearance
                    </p>
                  </div>
                  {activeAppearanceAccordion !== 3 && (
                    <div className="filterSelectedVal">
                      Selected :{" "}
                      <span>
                        {" "}
                        Upper clothing colors: {selectUpperClothingColors.length} ; Lower clothing colors: {selectLowerClothingColors.length}{" "}
                      </span>
                    </div>
                  )}
                </div>
              </AccordionTitle>
            </AccordionHeader>
            <AccordionDetail>
              <div
                className="flexColumn apperanceColorWrapper"
                style={{
                  marginTop: "10px",
                  marginBottom: "20px"
                }}
              >
                <div
                  style={{
                    color: "#6F7171",
                    marginBottom: "5px"
                  }}
                >
                  {" "}
                  <b> Upper clothing color </b>
                  {eventAppColorsClassList.length === selectUpperClothingColors.length && (
                    <span
                      style={{
                        textDecoration: "underline",
                        float: "right",
                        cursor: "pointer"
                      }}
                      data-testid={STATISTICS_TEST_IDS.DESELECT_ALL_UPPER_CLOTHING}
                      onClick={clearUpperClothingSelection}
                    >
                      {" "}
                      Deselect all{" "}
                    </span>
                  )}
                  {eventAppColorsClassList.length !== selectUpperClothingColors.length && (
                    <span
                      style={{
                        textDecoration: "underline",
                        float: "right",
                        cursor: "pointer"
                      }}
                      data-testid={STATISTICS_TEST_IDS.SELECT_ALL_UPPER_CLOTHING}
                      onClick={selectAllUpperClothingSelection}
                    >
                      {" "}
                      Select all{" "}
                    </span>
                  )}
                </div>
                <div className="">
                  <div style={{ display: "inline-block" }}>{renderUpperClothingColorBlocks(eventAppColorsClassList)}</div>
                </div>
              </div>

              <div className="flexColumn apperanceColorWrapper">
                <div
                  style={{
                    color: "#6F7171",
                    marginBottom: "5px"
                  }}
                >
                  {" "}
                  <b> Lower clothing color </b>
                  {eventAppColorsClassList.length === selectLowerClothingColors.length && (
                    <span
                      style={{
                        textDecoration: "underline",
                        float: "right",
                        cursor: "pointer"
                      }}
                      data-testid={STATISTICS_TEST_IDS.DESELECT_ALL_LOWER_CLOTHING}
                      onClick={clearLowerClothingSelection}
                    >
                      {" "}
                      Deselect all{" "}
                    </span>
                  )}
                  {eventAppColorsClassList.length !== selectLowerClothingColors.length && (
                    <span
                      style={{
                        textDecoration: "underline",
                        float: "right",
                        cursor: "pointer"
                      }}
                      data-testid={STATISTICS_TEST_IDS.SELECT_ALL_LOWER_CLOTHING}
                      onClick={selectAllLowerClothingSelection}
                    >
                      {" "}
                      Select all{" "}
                    </span>
                  )}
                </div>
                <div className="">
                  <div style={{ display: "inline-block" }}>{renderLowerClothingColorBlocks(eventAppColorsClassList)}</div>
                </div>
              </div>
            </AccordionDetail>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};

export default AppearanceSelection;
